module.exports = __webpack_public_path__ + "static/slide8_open.e060f41b.png";